export enum EDirectoryRegions {
  POLE = 'pole',
  SBER = 'sber',
}
